import React, { useState } from 'react';
import '../../styles/AdminModal.css';
import { deleteBlogPost } from '../../services/AdminBlogService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const BlogPostDeleteModal = ({ isOpen, onClose, onSuccess, post }) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!post) return;

    setLoading(true);
    try {
      await deleteBlogPost(post.id);
      onSuccess();
    } catch (error) {
      console.error('Error deleting blog post:', error);
      alert('Failed to delete blog post. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !post) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Delete Blog Post</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>

        <div className="admin__modal-body">
          <div className="delete-warning">
            <p>
              Are you sure you want to delete the blog post "<strong>{post.title}</strong>"?
            </p>
            <p>This action cannot be undone.</p>
          </div>
        </div>

        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="button danger" onClick={handleDelete} disabled={loading}>
            {loading ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogPostDeleteModal; 